import { render, staticRenderFns } from "./CustomAttributeDropDownItem.vue?vue&type=template&id=0258e253&scoped=true&"
import script from "./CustomAttributeDropDownItem.vue?vue&type=script&lang=js&"
export * from "./CustomAttributeDropDownItem.vue?vue&type=script&lang=js&"
import style0 from "./CustomAttributeDropDownItem.vue?vue&type=style&index=0&id=0258e253&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0258e253",
  null
  
)

export default component.exports